module.exports = __webpack_public_path__ + "img/B20-20190415_05.78f1033a.jpg";